import uuid from 'uuid';
import {base64} from '@webex/common';

import {isImage} from './files';

/**
 * Constructs a default activity
 *
 * @export
 * @param {object} conversation
 * @param {object} activityObject
 * @param {any} actor
 * @returns {object}
 */
export function constructActivity(conversation, activityObject, actor) {
  const clientTempId = `sdk-widget-${uuid.v4()}`;

  return {
    actor: {
      displayName: actor.name,
      id: actor.id,
      objectType: 'person'
    },
    // Needed for round trip
    clientTempId,
    id: clientTempId,
    // Minimum properties needed by API
    object: activityObject,
    target: {
      id: conversation.id,
      objectType: 'conversation'
    },
    verb: 'post',
    published: new Date().toISOString(),
    clientPublished: new Date().toISOString(),
    _status: 'pending',
    _meta: {
      actor,
      conversation,
      text: activityObject
    }
  };
}


/**
 * Constructs a share activity
 *
 * @export
 * @param {object} conversation
 * @param {object} activityObject
 * @param {object} actor
 * @param {array} files
 * @param {object} shareActivity
 * @returns {object}
 */
export function constructActivityWithContent(conversation, activityObject, actor, files, shareActivity) {
  const activity = constructActivity(conversation, activityObject, actor);

  activity.object.objectType = 'content';
  activity.verb = 'share';
  const items = files.map((file) => {
    const item = Object.assign({}, file, {
      objectType: 'file',
      url: file.clientTempId
    });

    if (isImage(file)) {
      item.image = {
        url: file.thumbnail
      };
    }

    return item;
  });

  activity.object.files = {
    items
  };
  // eslint-disable-reason _meta comes from SDK
  // eslint-disable-next-line no-underscore-dangle
  activity._meta.shareActivity = shareActivity;

  return activity;
}


/**
 * Constructs an Event from incoming Mercury Activity
 *
 * @export
 * @param {Object} activity from Mercury
 * @returns {Object}
 */
export function constructActivityEventData(activity) {
  const hydraActivity = Object.assign({}, activity);

  hydraActivity.actorId = base64.encode(`ciscospark://us/PEOPLE/${activity.actor.id}`);
  // Base64 encode uuids
  hydraActivity.id = base64.encode(`ciscospark://us/MESSAGE/${activity.id}`);
  hydraActivity.roomId = base64.encode(`ciscospark://us/ROOM/${activity.target.id}`);
  hydraActivity.target = Object.assign({}, activity.target, {
    id: base64.encode(`ciscospark://us/ROOM/${activity.target.id}`)
  });

  return hydraActivity;
}
